var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.useTrailSubscription
        ? _c("q-table", {
            ref: "table",
            staticClass: "q-mt-lg",
            attrs: {
              data: _vm.certificates,
              columns: _vm.columns_certificates,
              "row-key": "id",
              pagination: _vm.server_pagination,
              loading: _vm.loading,
              "no-data-label": _vm.$t("no_data_avaliable"),
              "no-results-label": _vm.$t("no_results_found"),
              "loading-label": _vm.$t("loading_data"),
              "rows-per-page-label": _vm.$t("items_per_page"),
              "rows-per-page-options": [5, 10, 50, 100],
              filter: _vm.filter_users,
              "binary-state-sort": ""
            },
            on: {
              "update:pagination": function($event) {
                _vm.server_pagination = $event
              },
              request: _vm.requestCertificates
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "top",
                  fn: function(props) {
                    return [
                      _c("q-search", {
                        attrs: {
                          icon: "fas fa-search",
                          placeholder: _vm.$t("search"),
                          debounce: 500
                        },
                        model: {
                          value: _vm.filter_users,
                          callback: function($$v) {
                            _vm.filter_users = $$v
                          },
                          expression: "filter_users"
                        }
                      }),
                      _c("div", { staticClass: "col" }),
                      _c("q-btn", {
                        attrs: {
                          color: "secondary",
                          icon: "fas fa-download",
                          label: _vm.$t("certified_report")
                        },
                        on: {
                          click: function($event) {
                            return _vm.downloadCertificate()
                          }
                        }
                      })
                    ]
                  }
                },
                {
                  key: "header",
                  fn: function(props) {
                    return _c(
                      "q-tr",
                      { attrs: { props: props } },
                      _vm._l(props.cols, function(col) {
                        return _c(
                          "q-th",
                          { key: col.name, attrs: { props: props } },
                          [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(_vm.$t(col.label)) +
                                "\n\t\t\t"
                            )
                          ]
                        )
                      }),
                      1
                    )
                  }
                },
                {
                  key: "body",
                  fn: function(props) {
                    return [
                      _c(
                        "q-tr",
                        { attrs: { props: props } },
                        [
                          _c(
                            "q-td",
                            { key: "user_full_name", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(props.row.user_full_name) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            { key: "user_email", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(props.row.user_email) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            { key: "result_date", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(props.row.result_date) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            {
                              key: "status",
                              attrs: { props: props, "auto-width": "" }
                            },
                            [
                              _c(
                                "q-chip",
                                {
                                  staticClass: "full-width text-center",
                                  attrs: {
                                    small: "",
                                    icon: _vm.getIconStatus(props.row.status),
                                    color: _vm.getColorStatus(props.row.status)
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          _vm.getTextStatus(props.row.status)
                                        )
                                      ) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "q-td",
                            { key: "user_branches", attrs: { props: props } },
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    "text-color": "white",
                                    label: props.row.user_branches.length,
                                    "no-ripple": ""
                                  }
                                },
                                [
                                  _c("q-tooltip", [
                                    props.row.user_branches.length > 0
                                      ? _c(
                                          "p",
                                          { staticClass: "tooltip q-mb-sm" },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(_vm.$t("branches")) +
                                                ":\n\t\t\t\t\t\t\t\t"
                                            ),
                                            _vm._l(
                                              props.row.user_branches,
                                              function(branch, index) {
                                                return _c(
                                                  "span",
                                                  { key: index },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(branch) +
                                                        "\n\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                    props.row.user_branches
                                                      .length -
                                                      1 >
                                                    index
                                                      ? _c("span", [
                                                          _vm._v(
                                                            ",\n\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ])
                                                      : _vm._e()
                                                  ]
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              2473349175
            )
          })
        : _vm._e(),
      _vm.useTrailSubscription
        ? _c(
            "q-tabs",
            {
              attrs: { color: "secondary" },
              model: {
                value: _vm.report,
                callback: function($$v) {
                  _vm.report = $$v
                },
                expression: "report"
              }
            },
            [
              _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "mandatory",
                  label: _vm.$t("mandatory")
                },
                slot: "title"
              }),
              _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "enrolled",
                  label: _vm.$t("enrolled")
                },
                slot: "title"
              }),
              _c(
                "q-tab-pane",
                { attrs: { name: "mandatory" } },
                [
                  _c("q-table", {
                    ref: "table",
                    attrs: {
                      data: _vm.mandatory,
                      columns: _vm.columns,
                      "row-key": "id",
                      pagination: _vm.server_pagination_mandatory,
                      loading: _vm.loading,
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      filter: _vm.filter_certificates_mandatory,
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.server_pagination_mandatory = $event
                      },
                      request: _vm.requestMandatoryCertificates
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "top",
                          fn: function(props) {
                            return [
                              _c("q-search", {
                                attrs: {
                                  icon: "fas fa-search",
                                  placeholder: _vm.$t("search"),
                                  debounce: 500
                                },
                                model: {
                                  value: _vm.filter_certificates_mandatory,
                                  callback: function($$v) {
                                    _vm.filter_certificates_mandatory = $$v
                                  },
                                  expression: "filter_certificates_mandatory"
                                }
                              }),
                              _c("div", { staticClass: "col" }),
                              _c("q-btn", {
                                attrs: {
                                  color: "secondary",
                                  icon: "fas fa-download",
                                  label: _vm.$t("certified_report")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.downloadCertificate()
                                  }
                                }
                              })
                            ]
                          }
                        },
                        {
                          key: "header",
                          fn: function(props) {
                            return _c(
                              "q-tr",
                              { attrs: { props: props } },
                              _vm._l(props.cols, function(col) {
                                return _c(
                                  "q-th",
                                  { key: col.name, attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t(col.label)) +
                                        "\n\t\t\t\t\t"
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          }
                        },
                        {
                          key: "body",
                          fn: function(props) {
                            return [
                              _c(
                                "q-tr",
                                { attrs: { props: props } },
                                [
                                  _c(
                                    "q-td",
                                    {
                                      key: "full_name",
                                      attrs: { props: props }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(props.row.full_name) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _c(
                                    "q-td",
                                    { key: "email", attrs: { props: props } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(props.row.email) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _c(
                                    "q-td",
                                    {
                                      key: "result_date",
                                      attrs: { props: props }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(props.row.result_date) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _c(
                                    "q-td",
                                    { key: "score", attrs: { props: props } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            props.row.score
                                              ? props.row.score.toFixed(2)
                                              : ""
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _c(
                                    "q-td",
                                    { key: "percent", attrs: { props: props } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            props.row.percent
                                              ? props.row.percent.toFixed(2) +
                                                  "%"
                                              : ""
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _c(
                                    "q-td",
                                    {
                                      key: "status",
                                      attrs: { props: props, "auto-width": "" }
                                    },
                                    [
                                      _c(
                                        "q-chip",
                                        {
                                          staticClass: "full-width text-center",
                                          attrs: {
                                            small: "",
                                            icon: _vm.getIconStatus(
                                              props.row.status
                                            ),
                                            color: _vm.getColorStatus(
                                              props.row.status
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.getTextStatus(
                                                    props.row.status
                                                  )
                                                )
                                              ) +
                                              "\n\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-td",
                                    {
                                      key: "user_branches",
                                      attrs: { props: props }
                                    },
                                    [
                                      _c(
                                        "q-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            "text-color": "white",
                                            label: props.row.user_branches
                                              ? props.row.user_branches.length
                                              : 0,
                                            "no-ripple": ""
                                          }
                                        },
                                        [
                                          _c("q-tooltip", [
                                            props.row.user_branches &&
                                            props.row.user_branches.length > 0
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "tooltip q-mb-sm"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t("branches")
                                                        ) +
                                                        ":\n\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _vm._l(
                                                      props.row.user_branches,
                                                      function(branch, index) {
                                                        return _c(
                                                          "span",
                                                          { key: index },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(branch) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            ),
                                                            props.row
                                                              .user_branches
                                                              .length -
                                                              1 >
                                                            index
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    ",\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4232664720
                    )
                  })
                ],
                1
              ),
              _c(
                "q-tab-pane",
                { attrs: { name: "enrolled" } },
                [
                  _c("q-table", {
                    ref: "table",
                    attrs: {
                      data: _vm.enrolled,
                      columns: _vm.columns_enrolled_users,
                      "row-key": "id",
                      pagination: _vm.server_pagination_enrolled,
                      loading: _vm.loading,
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      filter: _vm.filter_certificates_enrolled,
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.server_pagination_enrolled = $event
                      },
                      request: _vm.requestEnrolledCertificates
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "top",
                          fn: function(props) {
                            return [
                              _c("q-search", {
                                attrs: {
                                  icon: "fas fa-search",
                                  placeholder: _vm.$t("search"),
                                  debounce: 500
                                },
                                model: {
                                  value: _vm.filter_certificates_enrolled,
                                  callback: function($$v) {
                                    _vm.filter_certificates_enrolled = $$v
                                  },
                                  expression: "filter_certificates_enrolled"
                                }
                              }),
                              _c("div", { staticClass: "col" }),
                              _c("q-btn", {
                                staticClass: "q-mr-md",
                                attrs: {
                                  color: "secondary",
                                  icon: "fas fa-plus",
                                  label: _vm.$t("enroll_users")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showEnrollUsers()
                                  }
                                }
                              })
                            ]
                          }
                        },
                        {
                          key: "header",
                          fn: function(props) {
                            return _c(
                              "q-tr",
                              { attrs: { props: props } },
                              _vm._l(props.cols, function(col) {
                                return _c(
                                  "q-th",
                                  { key: col.name, attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t(col.label)) +
                                        "\n\t\t\t\t\t"
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          }
                        },
                        {
                          key: "body",
                          fn: function(props) {
                            return [
                              _c(
                                "q-tr",
                                { attrs: { props: props } },
                                [
                                  _c(
                                    "q-td",
                                    {
                                      key: "full_name",
                                      attrs: { props: props }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(props.row.full_name) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _c(
                                    "q-td",
                                    { key: "email", attrs: { props: props } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(props.row.email) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _c(
                                    "q-td",
                                    {
                                      key: "result_date",
                                      attrs: { props: props }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(props.row.result_date) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _c(
                                    "q-td",
                                    { key: "score", attrs: { props: props } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            props.row.score
                                              ? props.row.score.toFixed(2)
                                              : ""
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _c(
                                    "q-td",
                                    { key: "percent", attrs: { props: props } },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            props.row.percent
                                              ? props.row.percent.toFixed(2) +
                                                  "%"
                                              : ""
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _c(
                                    "q-td",
                                    {
                                      key: "status",
                                      attrs: { props: props, "auto-width": "" }
                                    },
                                    [
                                      _c(
                                        "q-chip",
                                        {
                                          staticClass: "full-width text-center",
                                          attrs: {
                                            small: "",
                                            icon: _vm.getIconStatusEnrolled(
                                              props.row
                                            ),
                                            color: _vm.getColorStatusEnrolled(
                                              props.row
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.getTextStatusEnrolled(
                                                    props.row
                                                  )
                                                )
                                              ) +
                                              "\n\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-td",
                                    {
                                      key: "user_branches",
                                      attrs: { props: props }
                                    },
                                    [
                                      _c(
                                        "q-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            "text-color": "white",
                                            label: props.row.user_branches
                                              ? props.row.user_branches.length
                                              : 0,
                                            "no-ripple": ""
                                          }
                                        },
                                        [
                                          _c("q-tooltip", [
                                            props.row.user_branches &&
                                            props.row.user_branches.length > 0
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "tooltip q-mb-sm"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t("branches")
                                                        ) +
                                                        ":\n\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _vm._l(
                                                      props.row.user_branches,
                                                      function(branch, index) {
                                                        return _c(
                                                          "span",
                                                          { key: index },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(branch) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            ),
                                                            props.row
                                                              .user_branches
                                                              .length -
                                                              1 >
                                                            index
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    ",\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-td",
                                    {
                                      key: "actions",
                                      attrs: { "auto-width": "", props: props }
                                    },
                                    [
                                      _c("q-btn", {
                                        attrs: {
                                          flat: "",
                                          round: "",
                                          color: "negative",
                                          icon: "far fa-trash-alt"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeEnrolledUser(
                                              props.row.actions
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      956463985
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.status == 1
        ? _c("div", { staticClass: "row gutter-sm justify-end q-mt-sm" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "secondary",
                    label: _vm.$t("notify_pending_users"),
                    icon: "far fa-paper-plane"
                  },
                  on: { click: _vm.showNotifyUsers }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_notify_users,
            callback: function($$v) {
              _vm.show_notify_users = $$v
            },
            expression: "show_notify_users"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_notify_users = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("notify_pending_users")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    ref: "table",
                    staticClass: "q-mt-lg",
                    attrs: {
                      data: _vm.users_notify,
                      columns: _vm.columns_notify_users,
                      "row-key": "user_id",
                      pagination: _vm.server_pagination,
                      loading: _vm.loading,
                      filter: _vm.filter,
                      selection: "multiple",
                      selected: _vm.users_notify_selected,
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.server_pagination = $event
                      },
                      request: _vm.requestNotifyUsers,
                      "update:selected": function($event) {
                        _vm.users_notify_selected = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("q-search", {
                              attrs: {
                                icon: "fas fa-search",
                                placeholder: _vm.$t("search"),
                                debounce: 500
                              },
                              model: {
                                value: _vm.filter,
                                callback: function($$v) {
                                  _vm.filter = $$v
                                },
                                expression: "filter"
                              }
                            }),
                            _c("div", { staticClass: "col" })
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-th",
                                { attrs: { "auto-width": "" } },
                                [
                                  _c("q-checkbox", {
                                    attrs: { "indeterminate-value": "some" },
                                    model: {
                                      value: props.selected,
                                      callback: function($$v) {
                                        _vm.$set(props, "selected", $$v)
                                      },
                                      expression: "props.selected"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._l(props.cols, function(col) {
                                return _c(
                                  "q-th",
                                  { key: col.name, attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t(col.label)) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return [
                            _c(
                              "q-tr",
                              { attrs: { props: props } },
                              [
                                _c(
                                  "q-td",
                                  { attrs: { "auto-width": "" } },
                                  [
                                    _c("q-checkbox", {
                                      attrs: { color: "primary" },
                                      model: {
                                        value: props.selected,
                                        callback: function($$v) {
                                          _vm.$set(props, "selected", $$v)
                                        },
                                        expression: "props.selected"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "q-td",
                                  {
                                    key: "user_full_name",
                                    attrs: { props: props }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(props.row.user_full_name) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  {
                                    key: "user_email",
                                    attrs: { props: props }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(props.row.user_email) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _c(
                                  "q-td",
                                  {
                                    key: "user_profile",
                                    attrs: { props: props }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(props.row.user_profile) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm.status == 1
                    ? _c(
                        "div",
                        { staticClass: "row gutter-sm justify-end q-mt-sm" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-xs-12 col-sm-4" },
                            [
                              _c("q-btn", {
                                staticClass: "full-width",
                                attrs: {
                                  color: "primary",
                                  label: _vm.$t("notify_selected_users"),
                                  icon: "far fa-check-square",
                                  disable:
                                    _vm.users_notify_selected.length === 0
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.confirmTypeNotification(
                                      "selected"
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-xs-12 col-sm-4" },
                            [
                              _c("q-btn", {
                                staticClass: "full-width",
                                attrs: {
                                  color: "secondary",
                                  label: _vm.$t("notify_all_users"),
                                  icon: "fas fa-users"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.confirmTypeNotification("all")
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("personalized") },
                    on: {
                      click: function($event) {
                        return _vm.showPersonalizeMessage()
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "positive", label: _vm.$t("default") },
                    on: {
                      click: function($event) {
                        return _vm.notifyUsers("default")
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_select_notification_message,
            callback: function($$v) {
              _vm.show_select_notification_message = $$v
            },
            expression: "show_select_notification_message"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  _vm.type_notification === "all"
                    ? "notify_all_users"
                    : "notify_selected_users"
                )
              )
            )
          ]),
          _c("span", { attrs: { slot: "body" }, slot: "body" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("what_kind_of_message_you_want_to_send")) +
                "\n\t\t"
            )
          ])
        ]
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.personalize_message,
            callback: function($$v) {
              _vm.personalize_message = $$v
            },
            expression: "personalize_message"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.personalize_message = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("personalize_message")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("title"),
                          error: _vm.$v.notification_title.$error
                        },
                        on: { input: _vm.$v.notification_title.$touch },
                        model: {
                          value: _vm.notification_title,
                          callback: function($$v) {
                            _vm.notification_title = $$v
                          },
                          expression: "notification_title"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("message")))
                      ]),
                      _c("q-editor", {
                        attrs: {
                          error: _vm.$v.notification_body.$error,
                          toolbar: [
                            ["bold", "italic", "strike", "underline"],
                            ["left", "center", "right", "justify"],
                            ["link", "upload"],
                            [
                              {
                                label: null,
                                icon: "fas fa-font",
                                fixedLabel: true,
                                fixedIcon: true,
                                list: "no-icons",
                                options: [
                                  "p",
                                  "h1",
                                  "h2",
                                  "h3",
                                  "h4",
                                  "h5",
                                  "h6",
                                  "code"
                                ]
                              },
                              {
                                label: null,
                                icon: "fas fa-text-height",
                                fixedLabel: true,
                                fixedIcon: true,
                                list: "no-icons",
                                options: [
                                  "size-1",
                                  "size-2",
                                  "size-3",
                                  "size-4",
                                  "size-5",
                                  "size-6",
                                  "size-7"
                                ]
                              },
                              "removeFormat"
                            ],
                            ["quote", "unordered", "ordered"]
                          ],
                          definitions: {
                            bold: { label: null, icon: "fas fa-bold" },
                            italic: { label: null, icon: "fas fa-italic" },
                            strike: {
                              label: null,
                              icon: "fas fa-strikethrough"
                            },
                            underline: {
                              label: null,
                              icon: "fas fa-underline"
                            },
                            left: { label: null, icon: "fas fa-align-left" },
                            center: {
                              label: null,
                              icon: "fas fa-align-center"
                            },
                            right: { label: null, icon: "fas fa-align-right" },
                            justify: {
                              label: null,
                              icon: "fas fa-align-justify"
                            },
                            link: { label: null, icon: "fas fa-link" },
                            removeFormat: {
                              label: null,
                              icon: "fas fa-eraser"
                            },
                            quote: { label: null, icon: "fas fa-quote-right" },
                            unordered: { label: null, icon: "fas fa-list-ul" },
                            ordered: { label: null, icon: "fas fa-list-ol" }
                          }
                        },
                        on: { input: _vm.$v.notification_body.$touch },
                        model: {
                          value: _vm.notification_body,
                          callback: function($$v) {
                            _vm.notification_body = $$v
                          },
                          expression: "notification_body"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-sm" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("cancel")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("cancel"),
                            icon: "fas fa-chevron-left"
                          },
                          on: {
                            click: function($event) {
                              _vm.personalize_message = false
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("save")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "secondary",
                            label: _vm.$t("send"),
                            icon: "far fa-paper-plane"
                          },
                          on: {
                            click: function($event) {
                              return _vm.notifyUsers("personalized")
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          on: {
            ok: function($event) {
              _vm.users_notified = false
            }
          },
          model: {
            value: _vm.users_notified,
            callback: function($$v) {
              _vm.users_notified = $$v
            },
            expression: "users_notified"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("notify_pending_users")))
          ]),
          _c("span", { attrs: { slot: "body" }, slot: "body" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("pending_users_were_notified")) +
                "\n\t\t"
            )
          ])
        ]
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_enroll_users,
            callback: function($$v) {
              _vm.show_enroll_users = $$v
            },
            expression: "show_enroll_users"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_enroll_users = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("enroll_users")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    attrs: {
                      data: _vm.users_to_enroll,
                      columns: _vm.columns_enroll_user,
                      pagination: _vm.server_pagination_users_to_enroll,
                      loading: _vm.loading,
                      selection: "multiple",
                      selected: _vm.selected_users_to_enroll,
                      filter: _vm.filter_certificates_users_to_enroll,
                      "row-key": "id",
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.server_pagination_users_to_enroll = $event
                      },
                      request: _vm.requestUsersToEnroll,
                      "update:selected": function($event) {
                        _vm.selected_users_to_enroll = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("q-search", {
                              attrs: {
                                icon: "fas fa-search",
                                placeholder: _vm.$t("search"),
                                debounce: 500
                              },
                              model: {
                                value: _vm.filter_certificates_users_to_enroll,
                                callback: function($$v) {
                                  _vm.filter_certificates_users_to_enroll = $$v
                                },
                                expression:
                                  "filter_certificates_users_to_enroll"
                              }
                            }),
                            _c("div", { staticClass: "col" }),
                            _vm.selected_users_to_enroll.length > 0
                              ? _c("q-btn", {
                                  attrs: {
                                    color: "positive",
                                    icon: "far fa-save",
                                    label: _vm.$t("enroll")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.enrollUsers()
                                    }
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-th",
                                { attrs: { "auto-width": "" } },
                                [
                                  _c("q-checkbox", {
                                    attrs: { "indeterminate-value": "some" },
                                    model: {
                                      value: props.selected,
                                      callback: function($$v) {
                                        _vm.$set(props, "selected", $$v)
                                      },
                                      expression: "props.selected"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._l(props.cols, function(col) {
                                return _c(
                                  "q-th",
                                  { key: col.name, attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t(col.label)) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-td",
                                { attrs: { "auto-width": "" } },
                                [
                                  _c("q-checkbox", {
                                    attrs: { color: "primary" },
                                    model: {
                                      value: props.selected,
                                      callback: function($$v) {
                                        _vm.$set(props, "selected", $$v)
                                      },
                                      expression: "props.selected"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "id", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.id) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "full_name", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.full_name) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "email", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.email) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "user_branches",
                                  attrs: { props: props }
                                },
                                [
                                  _c(
                                    "q-btn",
                                    {
                                      attrs: {
                                        color: "primary",
                                        "text-color": "white",
                                        label: props.row.user_branches
                                          ? props.row.user_branches.length
                                          : 0,
                                        "no-ripple": ""
                                      }
                                    },
                                    [
                                      _c("q-tooltip", [
                                        props.row.user_branches &&
                                        props.row.user_branches.length > 0
                                          ? _c(
                                              "p",
                                              {
                                                staticClass: "tooltip q-mb-sm"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(_vm.$t("branches")) +
                                                    ":\n\t\t\t\t\t\t\t\t\t\t"
                                                ),
                                                _vm._l(
                                                  props.row.user_branches,
                                                  function(branch, index) {
                                                    return _c(
                                                      "span",
                                                      { key: index },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(branch) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                        ),
                                                        props.row.user_branches
                                                          .length -
                                                          1 >
                                                        index
                                                          ? _c("span", [
                                                              _vm._v(
                                                                ",\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }